import { applyMiddleware, createStore as baseCreateStore } from 'redux';
import thunk from 'redux-thunk';

export const createReducer = (initialState, reducerMap) => (state = initialState, action) => {
  const handle = reducerMap[action.type];
  
  if (typeof handle === 'function') {
    return handle(state, action.payload);
  }

  return state;
};

export const createStore = (reducers, state = {}) => {
  return baseCreateStore(reducers, state, applyMiddleware(thunk));
};